import { Component, Inject, OnInit} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DashboardService } from '../dashboard/dashboard.service';
import { MatSnackBar} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { validateVerticalPosition } from '@angular/cdk/overlay';
import {ErrorStateMatcher} from '@angular/material/core';


export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
	  const isSubmitted = form && form.submitted;
	  return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
	}
}

/**
 * @title Dialog Overview
 */
@Component({
  selector: 'app-newactivity',
  templateUrl: './newactivity.component.html',
  styleUrls: ['./newactivity.component.css']
})
export class NewactivityComponent{


  constructor(public dialog: MatDialog ) {}

  openDialog(): void {
    this.dialog.open(DialogOverviewExampleDialog, {
      data: {}
    });
  }
}


@Component({
  selector: 'dialog-model',
  templateUrl: 'dialog-model.html',
})
export class DialogOverviewExampleDialog {
  distance=0;
  h=0;
  m=0;
  s=0;
  dateActivity = new Date();
  metric = "miles";
  loading = false;
  paceMeterPerSecond;
  runForm;
  public get form() { return this.runForm.controls; }
  metrics: any= [
    {value: 'kilometers' },
    {value: 'meters' },
    {value: 'miles' },
    {value: 'yards' }
  ];
  matcher;
  formError = false;
  
  


  constructor(
    private dashboardService : DashboardService,
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    public _snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private router: Router) {

      this.runForm = this.formBuilder.group({
        distance: ['0', [Validators.required, Validators.pattern("^[0-9]+(\.[0-9]{1,2})?$")]] ,
        h: ['0', [Validators.required, Validators.maxLength(2)]],
        m: ['0',[Validators.required, Validators.max(59)]],
        s: ['0', [Validators.required,  Validators.max(59)]],
        dateActivity : [new Date(), Validators.required]
      });

      this.matcher = new MyErrorStateMatcher();
      this.onChanges();
  }


  onChanges(): void {

    this.runForm.valueChanges.subscribe(change => {
      this.paceMeterPerSecond = 5;
      this.formError = false;
    });

  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  saveRun(){
    if (this.runForm.invalid) {
      this.loading = false;
      this.formError = true;
			return;
    }

    this.loading = true;
    let durationApi = (this.form.h.value*3600)+(this.form.m.value*60)+(this.form.s.value*1);
    let dateApi = this.form.dateActivity.value;
    let distanceApi = this.form.distance.value;
    let snackBar = this._snackBar;
    let that = this;

    switch (this.metric) {
      case 'kilometers':
        distanceApi = distanceApi * 1000;
        break;
      case 'meters':
        distanceApi = distanceApi;
        break;
      case 'miles':
        distanceApi = distanceApi * 1609.34;
        break;
      case 'yards':
        distanceApi = distanceApi * 0.9144;    
        break;
      default:
        break;
    }

    this.paceMeterPerSecond = distanceApi / durationApi;

    if(this.paceMeterPerSecond < 5.8 && this.paceMeterPerSecond > 1){
      this.dashboardService.addActivity(distanceApi, durationApi, dateApi)
        .subscribe(res => {
          that.router.navigateByUrl('/dashboard');
          window.location.reload();
        },
        err => {
          that._snackBar.open('An error occured please try again', 'Close', {
            duration: 3000
            });
            this.loading = false
        },
        () =>  this.loading = false);
    }else{
      this.loading = false
    }
  }
}

